console.log('ASCII Effect module loading');

const density = 'ㄱㄴㄷㄹㅁㅂㅅㅇㅈㅊㅋㅌㅍㅎㅏㅑㅓㅕㅗㅛㅜㅠㅡ';

class AsciiEffect {
    constructor() {
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
        this.holder = document.getElementById('sketch-holder');
        
        // ✅ mobile adaptation size and detail
        if (window.innerWidth <= 360) {
            this.canvas.width = window.innerWidth * 0.42;
            this.canvas.height = window.innerHeight * 0.31;
            this.cellSize = 4; // More details for mobile cells smaller
            this.fontSize = '5px';
        } else if (window.innerWidth <= 375) {
            this.canvas.width = window.innerWidth * 0.40;
            this.canvas.height = window.innerHeight * 0.28;
            this.cellSize = 4; // More details for mobile cells smaller
            this.fontSize = '5px'; // 
        } else if (window.innerWidth <= 390) {
            this.canvas.width = window.innerWidth * 0.40;
            this.canvas.height = window.innerHeight * 0.28;
            this.cellSize = 3; // Detail Normal
            this.fontSize = '3px';
        } else if (window.innerWidth <= 412) {
            this.canvas.width = window.innerWidth * 0.37;
            this.canvas.height = window.innerHeight * 0.30;
            this.cellSize = 4; // Détail normal
            this.fontSize = '5px';
        } else if (window.innerWidth <= 425) {
            this.canvas.width = window.innerWidth * 0.40;
            this.canvas.height = window.innerHeight * 0.28;
            this.cellSize = 4; // Détail normal
            this.fontSize = '6px';
        } else if (window.innerWidth > 425 && window.innerWidth <= 480) {
            //Speficic breakpoint 425px-480px
            this.canvas.width = window.innerWidth * 0.36; 
            this.canvas.height = window.innerHeight * 0.28; 
            this.cellSize = 6;
            this.fontSize = '7px';
        } else if (window.innerWidth <= 768) {
            this.canvas.width = window.innerWidth * 0.37;
            this.canvas.height = window.innerHeight * 0.32;
            this.cellSize = 6;
            this.fontSize = '6px';
        } else if (window.innerWidth <= 820) {
            this.canvas.width = window.innerWidth * 0.36;
            this.canvas.height = window.innerHeight * 0.30;
            this.cellSize = 4;
            this.fontSize = '6px';
        } else if (window.innerWidth <= 912) {
            this.canvas.width = window.innerWidth * 0.43;
            this.canvas.height = window.innerHeight * 0.34;
            this.cellSize = 3;
            this.fontSize = '6px';
        } else if (window.innerWidth <= 1024) {
            this.canvas.width = window.innerWidth * 0.39;
            this.canvas.height = window.innerHeight * 0.34;
            this.cellSize = 4;
            this.fontSize = '4px';
        } else {
            this.canvas.width = window.innerWidth * 0.25;
            this.canvas.height = window.innerHeight * 0.4;
            this.cellSize = 3;
            this.fontSize = '3px';
        }
        
        this.holder.appendChild(this.canvas);
        
        this.frameCount = 0;
        this.frameRate = 8;
        
        this.tempCanvas = document.createElement('canvas');
        this.tempCtx = this.tempCanvas.getContext('2d', {
            willReadFrequently: true,
            crossOrigin: 'anonymous' 
        });
        
        this.setupVideo();
        
        window.addEventListener('resize', () => this.resize());
    }
    
    setupVideo() {
        this.video = document.createElement('video');

        fetch('/static/video/video_test.mp4')
            .then(response => response.blob())
            .then(blob => {
                const blobURL = URL.createObjectURL(blob);
                this.video.src = blobURL  
            })
            .catch(error => {
                console.error('Error fetching video:', error);
            });

        this.video.autoplay = true;
        this.video.loop = true;
        this.video.muted = true;
        this.video.crossOrigin = 'anonymous';
        this.video.playsInline = true;
        this.video.style.display = 'none';
        this.video.style.display = 'none';
        this.video.style.visibility = 'hidden';
        this.video.style.opacity = '0';
        this.video.style.position = 'absolute';
        this.video.style.left = '-9999px';
        this.video.style.top = '-9999px';
        this.video.style.width = '0px';
        this.video.style.height = '0px';
        this.video.style.cssText = `
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        position: absolute !important;
        left: -9999px !important;
        top: -9999px !important;
        width: 0 !important;
        height: 0 !important;
        pointer-events: none !important;
        clip: rect(0 0 0 0) !important;
        clip-path: inset(50%) !important;
    `;
        
        this.video.addEventListener('loadeddata', () => {
            this.videoLoaded = true;
            this.video.play();
            this.tempCanvas.width = this.video.videoWidth;
            this.tempCanvas.height = this.video.videoHeight;
            this.animate();
        });

        const offscreenContainer = document.createElement('div');
        offscreenContainer.style.cssText = `
            position: absolute !important;
            left: -9999px !important;
            top: -9999px !important;
            width: 0 !important;
            height: 0 !important;
            overflow: hidden !important;
            opacity: 0 !important;
            pointer-events: none !important;
        `;
        offscreenContainer.appendChild(this.video);
        document.body.appendChild(offscreenContainer);
        
        this.video.addEventListener('loadeddata', () => {
            this.videoLoaded = true;
            this.video.play();
            this.tempCanvas.width = this.video.videoWidth;
            this.tempCanvas.height = this.video.videoHeight;
            this.animate();
        });
    }
    
    resize() {
        if (window.innerWidth <= 374) {
            this.canvas.width = window.innerWidth * 0.40;
            this.canvas.height = window.innerHeight * 0.18;
            this.cellSize = 4; // ✅ PLUS DE DÉTAIL
            this.fontSize = '6px';
        } else if (window.innerWidth <= 425) {
            this.canvas.width = window.innerWidth * 0.40;
            this.canvas.height = window.innerHeight * 0.28;
            this.cellSize = 6;
            this.fontSize = '7px';
        } else if (window.innerWidth > 425 && window.innerWidth <= 480) {
            this.canvas.width = window.innerWidth * 0.35;
            this.canvas.height = window.innerHeight * 0.28;
            this.cellSize = 6;
            this.fontSize = '7px';
        } else if (window.innerWidth <= 768) {
            this.canvas.width = window.innerWidth * 0.37;
            this.canvas.height = window.innerHeight * 0.32;
            this.cellSize = 8;
            this.fontSize = '8px';
        } else {
            this.canvas.width = window.innerWidth * 0.25;
            this.canvas.height = (window.innerHeight - 125) * 0.6;
            this.cellSize = 8;
            this.fontSize = '8px';
        }
    }
    
    getPixelBrightness(x, y) {
        const imageData = this.tempCtx.getImageData(x, y, 1, 1).data;
        return (imageData[0] * 0.3 + imageData[1] * 0.59 + imageData[2] * 0.11);
    }
    
    animate() {
        if (!this.videoLoaded) {
            requestAnimationFrame(() => this.animate());
            return;
        }

        this.frameCount++;
        if (this.frameCount % this.frameRate !== 0) {
            requestAnimationFrame(() => this.animate());
            return;
        }
        
        this.tempCtx.drawImage(this.video, 0, 0);
        this.ctx.fillStyle = 'rgba(0, 0, 0, 0.9)';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        
        // Use variable cell size
        this.ctx.font = `${this.fontSize} monospace`;
        
        for(let y = this.cellSize; y < this.canvas.height; y += this.cellSize) {
            for(let x = this.cellSize; x < this.canvas.width; x += this.cellSize) {
                const videoX = Math.floor(x * (this.video.videoWidth / this.canvas.width));
                const videoY = Math.floor(y * (this.video.videoHeight / this.canvas.height));
                let brightness = this.getPixelBrightness(videoX, videoY);
                
                brightness = Math.pow(brightness / 255, 0.7) * 255;
                
                const charIndex = Math.floor((brightness / 255) * (density.length - 1));
                const char = density[charIndex];
                
                const alpha = 0.4 + (brightness / 255) * 0.6;
                this.ctx.fillStyle = `rgba(255, 140, 0, ${alpha})`;
                
                if (brightness > 128) {
                    this.ctx.fillText(char, x + 1, y + 1);
                }
                this.ctx.fillText(char, x, y);
            }
        }
        
        requestAnimationFrame(() => this.animate());
    }
}

// Add export
export { AsciiEffect }; 
console.log('ASCII Effect module loaded');